module.exports = __webpack_public_path__ + "static/media/mx.7e86643c.svg";